angular.module('unica_grand_prix.grand_prix_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// GRAND PRIX
		.state('app.grand_prix', {
			url: '/grand-prix',
			abstract: true,
			views: {
				'mainContent': {
					templateUrl: './modules/grand-prix/templates/grand-prix.html',
					controller: 'GrandPrixBasicController'
				}
			},
			params: {
				need_auth: true
			}
		})

			// GRAND PRIX LIST AND DELETE
			.state('app.grand_prix.list', {
				url: '/list/:event_id/:invitation_list_id',
				views: {
					'grandPrixContent': {
						templateUrl: './modules/grand-prix/templates/list.html',
						controller: 'GrandPrixListController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Grand Prix',
					parent: function($scope) {
						return 'app.invitation_list.list({event_id:' + $scope.event_id + '})';
						// return 'app.event.detail({year: ' + $scope.year + ',id:' + $scope.event_id + ' })';
					}
				}

			})

			// GRAND PRIX LIST ZM
			.state('app.grand_prix.list_zm', {
				url: '/list-zm',
				views: {
					'grandPrixContent': {
						templateUrl: './modules/grand-prix/templates/list-zm.html',
						controller: 'GrandPrixListZmController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Liste Vincitori Grand Prix',
					parent: 'app.dashboard'
				}
			})

			// GRAND PRIX VIEW ZM
			.state('app.grand_prix.view_zm', {
				url: '/view-zm/:id',
				views: {
					'grandPrixContent': {
						templateUrl: './modules/grand-prix/templates/view-zm.html',
						controller: 'GrandPrixViewZmController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Gestisci Lista Vincitori',
					parent: 'app.grand_prix.list_zm'
				}
			});

});

